import { render, staticRenderFns } from "./CustomersDataSheetListIdentifier.vue?vue&type=template&id=7dcccd1a&"
import script from "./CustomersDataSheetListIdentifier.vue?vue&type=script&lang=js&"
export * from "./CustomersDataSheetListIdentifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports